import { ICompany } from 'app/shared/model/company.model';

export interface ITireAlertSetting {
  id?: number;
  grooveOdometer?: number | null;
  rotationOdometer?: number | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<ITireAlertSetting> = {};
